// extracted by mini-css-extract-plugin
module.exports = {"pxp-faq-section":"FAQSection_pxp-faq-section__DStHL"};